import { toTitleCase } from "../../../../Utils/stringUtls";
import {
  features,
  otpDeliveryMethods,
  yellowPathOtp,
  liveAgent,
  emailAgent,
} from "../../OptionalFeatures/DigitalWallet";
import { I2cIcon } from "@webcomponents/i2cwebcomponents/dist/react";

const DigitalWalletsOverview = ({ data }) => {
  const {
    of_dw_mobile_wallets,
    of_dw_mobile_wallet_other,
    of_dw_card_holders,
    of_dw_live_agent,
    of_dw_live_agent_other,
    of_dw_email_authentication,
    of_dw_email_authentication_other,
    of_dw_otp_delivery,
    of_dw_provisioning_process,
    of_dw_i2c_mobile_app_host,
    of_dw_service_enable_via,
  } = data["6_4"];
  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid gap-sm" className="">
        <div i2c-grid="12@md">
          <div className="fw-700 review-summary-sub-heading mb-4 font-bold">
            Digital Wallets
          </div>
        </div>
        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold">Mobile Wallets</div>
          <div
            className="overview-val-text"
            style={{
              display: "flex",
              gap: "var(--i2c-spacing-3)",
              flexWrap: "wrap",
            }}
          >
            {of_dw_mobile_wallets?.length
              ? features.map((wallet, index) =>
                  of_dw_mobile_wallets?.includes(wallet.value) ? (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "var(--i2c-spacing-2)",
                      }}
                      key={index}
                    >
                      <I2cIcon
                        src={wallet.icon}
                        style={{ fontSize: "var(--i2c-spacing-8-5)" }}
                      />
                      <span>

                        {wallet.value === "others"
                          ? toTitleCase(of_dw_mobile_wallet_other)
                          : wallet.label}
                         
                      </span>
                      {of_dw_mobile_wallets?.length  ? ", " : ""}
                    </span>
                  ) : (
                    ""
                  ),
                )
              : "-"}
          </div>{" "}
        </div>
        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold mb-4">
            Authentication for Yellow Path cardholders
          </div>
          <div className="overview-help-text font-bold">
            For Yellow Path (cardholders failing enrollment), please confirm
            what alternate methods for Cardholder Authentication will be used:
          </div>
          <div
            className="overview-val-text"
            style={{
              display: "flex",
              gap: "var(--i2c-spacing-3)",
              flexWrap: "wrap",
            }}
          >
            {of_dw_card_holders?.length
              ? yellowPathOtp.map((holder, index) =>
                  of_dw_card_holders?.includes(holder.value) ? (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "var(--i2c-spacing-2)",
                      }}
                      key={index}
                    >
                      <span>{holder.label},</span>
                    </span>
                  ) : (
                    ""
                  ),
                )
              : "-"}
          </div>
        </div>
        <div i2c-grid="12@md">
          {of_dw_card_holders?.includes("live-agent") && (
            <div i2c-grid="12@md" className="mb-8">
              <div className="overview-help-text font-bold">
                If opting for “Live Agent”, please confirm who will provide the
                contact center service for Live Agent support for cardholders:
              </div>
              <div className="overview-val-text">
                {of_dw_live_agent === "other"
                  ? toTitleCase(of_dw_live_agent_other ?? "")
                  : liveAgent.find((agent) => agent.value === of_dw_live_agent)
                      ?.label}
              </div>
            </div>
          )}
          {of_dw_card_holders?.includes("via-email") && (
            <div i2c-grid="12@md" className="mb-8">
              <div className="overview-help-text font-bold">
                If opting for “E-mail”, please confirm who will manage:
              </div>
              <div className="overview-val-text">
                {of_dw_email_authentication === "other"
                  ? toTitleCase(of_dw_email_authentication_other ?? "")
                  : liveAgent.find((agent) => agent.value === of_dw_live_agent)
                      ?.label}
              </div>
            </div>
          )}

          <div className="overview-help-text font-bold mb-4">OTP Delivery</div>
          <div className="overview-help-text font-bold">
            Please confirm how would you like the OTP to be delivered to
            cardholders
          </div>
          <div className="overview-val-text">
            {of_dw_otp_delivery?.length
              ? otpDeliveryMethods.map((source, index) =>
                  of_dw_otp_delivery?.includes(source.value) ? (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "var(--i2c-spacing-2)",
                      }}
                      key={index}
                    >
                      <span>{source.label},</span>
                    </span>
                  ) : (
                    ""
                  ),
                )
              : "-"}
          </div>
        </div>

        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold mb-4">
            Digital Wallet Provisioning Process
          </div>
          <div className="overview-help-text font-bold">
            Would you like to enable In-App Provisioning (Push Provisioning)
            with Digital Wallets?
          </div>
          <div className="overview-val-text">
            {" "}
            {of_dw_provisioning_process?.length
              ? of_dw_provisioning_process.toUpperCase()
              : "-"}
          </div>
        </div>

        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold">
            Will the mobile app be hosted by i2c Inc.?
          </div>
          <div className="overview-val-text">
            {" "}
            {of_dw_i2c_mobile_app_host?.length
              ? of_dw_i2c_mobile_app_host.toUpperCase()
              : "-"}
          </div>
        </div>
        {of_dw_i2c_mobile_app_host === "no" ? (
          <div i2c-grid="12@md">
            <div className="overview-help-text font-bold">
              If you are not taking i2c hosted mobile app, would you like to
              enable this service via:
            </div>
            <div className="overview-val-text">
              {of_dw_service_enable_via?.length
                ? of_dw_service_enable_via.toUpperCase()
                : "-"}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};
export default DigitalWalletsOverview;
